import React, {
    useEffect, useState, useMemo, useCallback, useRef
} from 'react';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { Loader } from '@jutro/components';
import { useSgTrackPageName } from 'saga-modules';
import { CepConstants, SgPolicyPaymentTile } from 'saga-cep-specific-components';
import SgCepSideMenu from 'sg-cep-side-menu';
import { AccountBillingDetailsService } from 'gw-capability-billing';
import { PolicyService } from 'gw-capability-policy';
import metadata from './PaymentPage.metadata.json5';
import './PaymentPage.messages';

function PaymentPage(props) {
    const {
        match: { params: { policyNumber } }
    } = props;
    const [isLoading, setLoadingState] = useState(true);
    const [selectedPolicyId, setSelectedPolicyId] = useState(undefined);
    const [policies, setPolicies] = useState([]);
    const isInitialPageRender = useRef(true);
    useSgTrackPageName(CepConstants.PAGE_NAMES.PAYMENTS);

    useEffect(() => {
        AccountBillingDetailsService.getAccountInvoiceStreamInformation_Ext().then((invoiceInfo) => {
            const result = invoiceInfo;
            PolicyService.getBasicPoliciesInformation().then((policiesInfo) => {
                result.forEach((p) => {
                    _.set(p, 'basicInformation', policiesInfo.find((el) => el.policyNumber === p.policyNumber_Ext));
                });
                setPolicies(result);
                if (result.length === 1) {
                    setSelectedPolicyId(result[0].policyNumber_Ext);
                }
                if (!_.isNil(policyNumber) && result.some((el) => el.policyNumber_Ext === policyNumber)) {
                    setSelectedPolicyId(policyNumber);
                }
            }).finally(() => {
                setLoadingState(false);
                isInitialPageRender.current = false;
            });
        });
    }, []);

    const selectPolicy = useCallback((policyId) => {
        setSelectedPolicyId(policyId);
    }, []);

    const generateOverrides = useMemo(() => {
        const overrides = policies.map((item, index) => {
            return {
                [`cepPaymentTile${index}`]: {
                    policy: item,
                    isOpened: selectedPolicyId === item.policyNumber_Ext,
                    selectPolicy,
                    isInitialPageRender
                }
            };
        });
        return Object.assign({}, ...overrides);
    }, [policies, selectedPolicyId, selectPolicy]);

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    const overrideProps = {
        cepPoliciesPaymentTiles: {
            data: policies
        },
        ...generateOverrides
    };

    const resolvers = {
        resolveComponentMap: {
            SgPolicyPaymentTile,
            SgCepSideMenu
        }
    };

    const renderedContentFromMetadata = renderContentFromMetadata(
        metadata.pageContent,
        overrideProps,
        resolvers
    );

    return (
        <div>
            {renderedContentFromMetadata}
        </div>
    );
}

export default PaymentPage;
